/* eslint-disable import/no-default-export */
import DisplayPromoCodeRenderer from './DisplayPromoCodeRenderer';

export default DisplayPromoCodeRenderer;
